import {
  AWS_CONFIG,
  USER_REQUEST_CONFIG,
  USER_PATH_CONFIG
} from "../constants";
import Utils from "../Utils";
export default class UserStorageManager {
  constructor(Storage, UserInfo, AwsStorageConfig) {
    this.Storage = Storage;
    this.Storage.configure(AwsStorageConfig || AWS_CONFIG.Storage);
    this.UserInfo = UserInfo;
    this.pathConfig = USER_PATH_CONFIG;
    this.requestConfig = USER_REQUEST_CONFIG;
  }

  get = async (path, config) => {
    return this.Storage.get(path, config)
      .then(data => {
        //console.log("get", data);
        return data;
      })
      .catch(err => {
        //console.log("get error");
        return null;
      });
  };

  list = (path, config) => {
    return this.Storage.list(path, config)
      .then(result => {
        return result;
      })
      .catch(err => {
        //console.log("list loading error for, path" + path);
        return [];
      });
  };

  put = async (projectKey, filename, extension, file, requestConfig) => {
    if (!filename || !file || !requestConfig) {
      console.error("put attributes missing", filename, file, requestConfig);
      return;
    }

    console.log("calling put");

    return this.Storage.put(
      Utils.path(projectKey, filename, extension),
      file,
      requestConfig
    )
      .then(result => {
        // console.log("Upload sucessfull");
      })
      .catch(err => console.log(err));
  };

  loadProjects = async () => {
    var db;
    var dbJson = await this.get(
      this.pathConfig.db,
      this.requestConfig.dbDownload
    );
 

    if (dbJson && dbJson.Body) {
      db = JSON.parse(dbJson.Body);
    } else {
      db = {
        userId: this.UserInfo.id,
        email: this.UserInfo.attributes.email,
        projects: []
      };
    }

    if (db.projects) {
      for (let i = 0; i < db.projects.length; i++) {
        let res = await this.get(
          //check for asset bundle meta file
          db.projects[i].projectKey + "/" + this.pathConfig.assetBundleMeta,
          this.requestConfig.output
        );

        if (res.length > 0) {


          if (!db.projects[i].isProcessed) {
            try {
              const meta = await fetch(res); //we need to fetch file in order to find whether it's there
              if (meta && meta.ok)
                db.projects[i].isProcessed = true;
            } catch (e) {
              db.projects[i].isProcessed = false;
            }
          }

          if (db.projects[i].isProcessed) {

            let webglRes = await this.get(
              //check for webGL compiled asset bundle file
              
              db.projects[i].projectKey + "/" + this.pathConfig.webglAssetBundleMeta,
              this.requestConfig.output
            );
            
            if (webglRes.length > 0) {
              try {
                const webglAvailable = await fetch(webglRes);
                if (webglAvailable && webglAvailable.ok){
                  db.projects[i].webglSupported = true;
                }
                else{
                  db.projects[i].webglSupported = false;
                }
              } catch (e) {
                  db.projects[i].webglSupported = false;
              }
            }
            

            let footPrintUrl = await this.get(
              db.projects[i].projectKey + "/" + this.pathConfig.footprint,
              this.requestConfig.footprint
            );
            db.projects[i].footprintUrl = footPrintUrl || null;


            let modelInfoRes = await this.get(
              db.projects[i].projectKey + "/" + this.pathConfig.modelInfo,
              this.requestConfig.outputJsonDownload
            );

            if (modelInfoRes && modelInfoRes.Body) {
              let parsed = JSON.parse(modelInfoRes.Body);
              if (parsed.boundsSize) {
                db.projects[i].boundsWidth = parsed.boundsSize.x;
                db.projects[i].boundsHeight = parsed.boundsSize.z;
              }
            } else {
              console.log("missing model info");
            }

            /*  let unityStatusRes = await this.get(
               db.projects[i].projectKey + "/" + this.pathConfig.unityStatus,
               this.requestConfig.outputJsonDownload
             );
 
             if (unityStatusRes && unityStatusRes.Body) {
               try {
                 Object.assign(db.projects[i], JSON.parse(unityStatusRes.Body));
               } catch {
                 console.error("status parsing error");
                 db.projects[i].unityStatus = "error";
                 db.projects[i].unityDuration = 0;
               }
             } else {
               db.projects[i].unityStatus = "waiting";
               db.projects[i].unityDuration = 0;
             }*/
          }



        }
      }
    }
    this.db = db;
    return db;
  };

  uploadNewModel = async (
    counter,
    file,
    projectName,
    filename,
    lat,
    lng,
    rot,
    desription
  ) => {
    let pr = new Utils.Project(counter, Utils.uuidv4(), projectName, filename, lat, lng, rot, desription);

    await this.put(
      pr.projectKey,
      pr.modelName,
      pr.modelExtension,
      file,
      this.requestConfig.input
    );

    let dbJson = await this.get(
      this.pathConfig.db,
      this.requestConfig.dbDownload
    );

    let db = {};
    if (dbJson && dbJson.Body) {
      db = JSON.parse(dbJson.Body);
    } else {
      db = new Utils.User(this.UserInfo.id, this.UserInfo.attributes.email);
      db.projects = [];
    }

    pr.fileSize = file.size;
    db.projects.push(pr);

    for (let i = 0; i < db.projects.length; i++) {
      if (db.projects[i].footprintUrl) delete db.projects[i].footprintUrl;
    }

    await this.put(
      null,
      this.pathConfig.db,
      "",
      JSON.stringify(db),
      this.requestConfig.db
    );
  };

  editProject = async (projectKey, newValues) => {
    let dbJson = await this.get(
      this.pathConfig.db,
      this.requestConfig.dbDownload
    );
    let db;
    if (dbJson && dbJson.Body) {
      db = JSON.parse(dbJson.Body);
    } else {
      throw new Error("Issue with db.json");
    }
    console.log("newvalues", newValues);

    for (let i = 0; i < db.projects.length; i++) {
      if (db.projects[i].projectKey === projectKey) {
        Object.assign(db.projects[i], newValues);
      }
    }
    await this.put(
      null,
      this.pathConfig.db,
      "",
      JSON.stringify(db),
      this.requestConfig.input
    );
  };

  removeProject = async (projectKey) => {
    let dbJson = await this.get(
      this.pathConfig.db,
      this.requestConfig.dbDownload
    );
    let db;
    if (dbJson && dbJson.Body) {
      db = JSON.parse(dbJson.Body);
    } else {
      throw new Error("Issue with db.json");
    }

    console.log("remove project - previous db", db);
    for (let i = 0; i < db.projects.length; i++) {
      if (db.projects[i].projectKey === projectKey) {
        db.projects.splice(i, 1);
        break;
      }
    }

    console.log("remove project- new db", db);
    await this.put(
      null,
      this.pathConfig.db,
      "",
      JSON.stringify(db),
      this.requestConfig.input
    );
  };

  //TODO implement
  loadModel = async (modelName)=>{

    var modelObject = await this.get(
      modelName + '/' + this.pathConfig.webglAssetBundle,
      this.requestConfig.output
    );

    return modelObject;
  }
}
